export const categories = [
  {
    id: "shehui",
    name: "社会热点",
    description: "聚焦公共事件、民生关切与城市治理话题，追踪事件进展与多方回应。",
    icon: "ri-community-line",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20stylized%20city%20skyline%20at%20dusk%20in%20muted%20slate%20blue%20and%20warm%20orange%20tones%2C%20geometric%20minimal%20illustration%2C%20clean%20modern%20editorial%20style%2C%20soft%20gradient%20background&width=600&height=600&seq=cat-shehui-01&orientation=squarish",
  },
  {
    id: "yule",
    name: "娱乐内幕",
    description: "盘点文娱行业的幕后故事、版权争议与节目制作话题，还原事件脉络。",
    icon: "ri-movie-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20stage%20spotlight%20and%20audience%20silhouette%20in%20deep%20slate%20blue%20with%20warm%20orange%20glow%2C%20minimal%20geometric%20illustration%2C%20clean%20modern%20editorial%20style%2C%20soft%20gradient%20background&width=600&height=600&seq=cat-yule-01&orientation=squarish",
  },
  {
    id: "caijing",
    name: "财经风云",
    description: "追踪上市公司、投资机构与消费金融动向，解析数字背后的逻辑。",
    icon: "ri-line-chart-line",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20financial%20chart%20bars%20and%20graph%20lines%20in%20deep%20slate%20blue%20with%20orange%20highlights%2C%20minimal%20geometric%20illustration%2C%20clean%20modern%20editorial%20style%2C%20soft%20gradient%20background&width=600&height=600&seq=cat-caijing-01&orientation=squarish",
  },
  {
    id: "wangluo",
    name: "网络揭秘",
    description: "关注网络黑产、隐私安全与平台生态，揭开流量背后的真实操作。",
    icon: "ri-global-line",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20network%20nodes%20and%20connection%20lines%20in%20deep%20slate%20blue%20with%20orange%20accent%20points%2C%20minimal%20geometric%20illustration%2C%20clean%20modern%20editorial%20style%2C%20soft%20gradient%20background&width=600&height=600&seq=cat-wangluo-01&orientation=squarish",
  },
  {
    id: "keji",
    name: "科技解密",
    description: "拆解智能硬件、数码消费与新兴技术的真实体验与潜在风险。",
    icon: "ri-cpu-line",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20circuit%20board%20chip%20and%20data%20lines%20in%20deep%20slate%20blue%20with%20warm%20orange%20accents%2C%20minimal%20geometric%20illustration%2C%20clean%20modern%20editorial%20style%2C%20soft%20gradient%20background&width=600&height=600&seq=cat-keji-01&orientation=squarish",
  },
  {
    id: "shenghuo",
    name: "生活真相",
    description: "关注消费陷阱、健康话题与日常服务，帮你看清宣传与现实的差距。",
    icon: "ri-shopping-bag-3-line",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20shopping%20bags%20and%20daily%20objects%20in%20deep%20slate%20blue%20with%20orange%20highlights%2C%20minimal%20geometric%20illustration%2C%20clean%20modern%20editorial%20style%2C%20soft%20gradient%20background&width=600&height=600&seq=cat-shenghuo-01&orientation=squarish",
  },
];